
// import { Link } from "react-router-dom";

// function Footer() { 
//   return (
// <footer className="bg-lime-700 text-white py-12 border-t border-lime-500">
//   <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:justify-between gap-10 px-6">

//     {/* About */}
//     <div className="flex-1 min-w-[200px]">
//       <h2
//         className="text-lime-100 font-bold text-2xl mb-4"
//         style={{ fontFamily: "'Playfair Display', serif" }}
//       >
//         MF Blinds & Carpets
//       </h2>
//       <p className="text-lime-50 text-sm leading-relaxed">
//         Premium Blinds, Carpets & luxurious Furniture. Expert installation with fresh and elegant look.
//       </p>

//       {/* Social Icons */}
//       <div className="flex gap-4 mt-6 flex-wrap md:flex-nowrap overflow-x-auto md:overflow-visible">
//         {[
//           { href: "https://www.instagram.com/mfblinds2002/", label: "Instagram", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png", extraClass: "rounded bg-white p-1" },
//           { href: "https://www.facebook.com/profile.php?id=61586165050487", label: "Facebook", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Facebook_colored_svg_copy-512.png" , extraClass: "rounded bg-white p-1" },
//           { href: "https://wa.me/+447405264139", label: "WhatsApp", src: "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" , extraClass: "rounded bg-white p-1" },
//           { href: "https://www.youtube.com/@TahirTechnology-ci6mz", label: "YouTube", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Youtube_colored_svg-512.png" , extraClass: "rounded bg-white p-1" },
//           { href: "https://www.tiktok.com/@mf.blinds?_r=1&_t=ZS-936MipXoCFU", label: "TikTok", src: "https://upload.wikimedia.org/wikipedia/en/a/a9/TikTok_logo.svg", extraClass: "w-[50px] rounded bg-white p-1" },
//           // { href: "https://www.linkedin.com/in/wahabnadeem", label: "LinkedIn", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Linkedin_unofficial_colored_svg-512.png" },
//           // { href: "https://twitter.com/wahabnadeem24", label: "Twitter", src: "https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Twitter_colored_svg-512.png" },
//         ].map((icon, i) => (
//           <a key={i} href={icon.href} target="_blank" rel="noopener noreferrer" aria-label={icon.label}>
//             <img src={icon.src} alt={icon.label} className={`w-7 h-7 hover:scale-110 transition-transform ${icon.extraClass || ""}`} />
//           </a>
//         ))}
//       </div>
//     </div>

//     {/* Quick Links */}
//     <div className="flex-1 min-w-[150px]">
//       <h3
//         className="text-lime-400 font-semibold text-lg mb-4"
//         style={{ fontFamily: "'Playfair Display', serif" }}
//       >
//         Quick Links
//       </h3>
//       <ul className="space-y-2 text-sm">
//         <li><Link to="/about" className="text-lime-50 hover:text-lime-200 transition-colors">About</Link></li>
//         <li><Link to="/contact" className="text-lime-50 hover:text-lime-200 transition-colors">Contact</Link></li>
//         <li><Link to="/faq" className="text-lime-50 hover:text-lime-200 transition-colors">FAQ</Link></li>
//       </ul>
//     </div>

//     {/* Contact */}
//     <div className="flex-1 min-w-[180px]">
//       <h3
//         className="text-lime-400 font-semibold text-lg mb-4"
//         style={{ fontFamily: "'Playfair Display', serif" }}
//       >
//         Contact Us
//       </h3>
//     <ul className="space-y-2 text-sm text-lime-50">
//     <li><a href="tel:+447405264139" target="_blank" rel="noopener noreferrer">📞 (+44) 7405264139</a></li>
//     <li><a href="mailto:blindsmf@gmail.com" target="_blank" rel="noopener noreferrer">🧧 blindsmf@gmail.com</a></li>
//     <li><a href="https://wa.me/447405264139" target="_blank" rel="noopener noreferrer">📍 Chat on WhatsApp (44) 7405264139</a></li>
// </ul>
//     </div>
//   </div>

//   {/* Footer Bottom */}
//   <div className="mt-10 border-t border-lime-500 pt-6 px-4 flex flex-col md:flex-row justify-between items-center text-sm text-lime-300">
//     <p className="text-center md:text-left" style={{ fontFamily: "'Playfair Display', serif" }}>
//       &copy; 2025 MF Blinds & Carpets. All rights reserved.
//     </p>
//   </div>
// </footer>


//   );
// }

// export default Footer;


// import { Link } from "react-router-dom";
// import { useState } from "react";

// import { FaInstagram, FaFacebookF, FaWhatsapp, FaTiktok, FaShieldAlt } from "react-icons/fa";
// function Footer() {

//   const [email, setEmail] = useState("");
//   const [showModal, setShowModal] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!email) {
//       return;
//     }

//     setShowModal(true);
//     setEmail("");
//   };


//   return (
//     <footer className="bg-white text-gray-800 border-t border-lime-200 pt-16">

//       <div className="max-w-7xl mx-auto px-6">

//         {/* TOP GRID */}
//         <div className="grid md:grid-cols-4 gap-12">

//           {/* BRAND */}
//           <div>
//             <h2 className="text-2xl font-bold text-lime-700 mb-4">
//               MF Blinds & Carpets
//             </h2>

//             <p className="text-sm text-gray-600 leading-relaxed">
//               Premium made-to-measure blinds, carpets and furniture installation services across UK.
//               Quality craftsmanship with professional fitting.
//             </p>

//             {/* SOCIAL */}
//             <div className="flex gap-3 mt-6">
//               {[
//                 "https://www.instagram.com/mfblinds2002/",
//                 "https://www.facebook.com/profile.php?id=61586165050487",
//                 "https://wa.me/447405264139",
//                 "https://www.tiktok.com/@mf.blinds"
//               ].map((link, i) => (
//                 <a key={i} href={link} target="_blank" rel="noreferrer">
//                   <div className="w-9 h-9 rounded-full bg-lime-600 text-white flex items-center justify-center hover:bg-lime-700 transition">
//                     {i === 0 && <FaInstagram />}
//                     {i === 1 && <FaFacebookF />}
//                     {i === 2 && <FaWhatsapp />}
//                     {i === 3 && <FaTiktok />}
//                   </div>
//                 </a>
//               ))}
//             </div>
//           </div>

//           {/* CUSTOMER SERVICE */}
//           <div>
//             <h3 className="text-lg font-semibold text-lime-600 mb-5">
//               Customer Service
//             </h3>

//             <ul className="space-y-2 text-sm text-gray-600">
//               <li>📞 0800 862 0464</li>
//               <li>🕐 9am - 5:30pm (7 Days)</li>
//               <li>🏠 Free Home Measurement</li>
//               <li>🛠 Professional Installation</li>
//               <li className="flex items-center gap-2">
//                 <FaShieldAlt className="" />
//                 12 Month Warranty
//               </li>
//             </ul>
//           </div>

//           {/* QUICK LINKS */}
//           <div>
//             <h3 className="text-lg font-semibold text-lime-600 mb-5">
//               Quick Links
//             </h3>

//             <ul className="space-y-2 text-sm text-gray-600">
//               <li><Link to="/about" className="hover:text-lime-600">About</Link></li>
//               <li><Link to="/contact" className="hover:text-lime-600">Contact</Link></li>
//               <li><Link to="/faq" className="hover:text-lime-600">FAQ</Link></li>
//               <li><Link to="/privacy" className="hover:text-lime-600">Privacy Policy</Link></li>
//               <li><Link to="/terms" className="hover:text-lime-600">Terms</Link></li>
//             </ul>
//           </div>

//           {/* NEWSLETTER */}
//           <div>
//             <h3 className="text-lg font-semibold text-lime-600 mb-5">
//               Join Our Newsletter
//             </h3>

//             <p className="text-sm text-gray-600 mb-4">
//               Get exclusive offers & installation discounts.
//             </p>
//             <div>
//               {/* Form */}
//               <form onSubmit={handleSubmit} className="flex shadow-lg rounded-xl overflow-hidden max-w-md mx-auto">
//                 <input
//                   placeholder="Enter your email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   className="w-full px-5 py-3 border border-lime-200 focus:outline-none"
//                 />

//                 <button
//                   type="submit"
//                   className="bg-lime-600 text-white px-6 hover:bg-lime-700 transition font-semibold"
//                 >
//                   Submit
//                 </button>
//               </form>

//               {/* Modal Popup */}
//              {showModal && (
//         <div className="fixed inset-0 flex items-center justify-center z-50">

//           {/* Overlay */}
//           <div
//             className="absolute inset-0 bg-black/60 backdrop-blur-md"
//             onClick={() => setShowModal(false)}
//           />

//           {/* Modal Box */}
//           <div className="relative bg-white rounded-3xl shadow-2xl p-10 text-center w-full max-w-md animate-[fadeIn_0.4s_ease]">

//             <div className="text-6xl mb-4 animate-bounce">
//               🎉
//             </div>
//             <h2 className="text-2xl font-bold mb-3 bg-gradient-to-r from-lime-600 to-green-600 bg-clip-text text-transparent">
//               You're In!
//             </h2>

//             <p className="text-gray-600 leading-relaxed mb-6">
//               Thank you for joining. We will send updates, offers and important notifications to your email.
//             </p>

//             <button
//               onClick={() => setShowModal(false)}
//               className="w-full bg-gradient-to-r from-lime-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition"
//             >
//               Continue
//             </button>

//           </div>
//         </div>
//       )}  

//             </div>

//           </div>

//         </div>

//         {/* PAYMENT + COPYRIGHT */}
//         <div className="border-t border-lime-200 mt-14 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">

//           <p>© 2025 MF Blinds & Carpets | All Rights Reserved</p>

//           <div className="flex gap-4 mt-4 md:mt-0">
//             <span>Visa</span>
//             <span>Mastercard</span>
//             <span>PayPal</span>
//           </div>

//         </div>

//       </div>
//     </footer>
//   );
// }

// export default Footer;


import { Link } from "react-router-dom";
import { useState } from "react";
import { FaInstagram, FaFacebookF, FaWhatsapp, FaTiktok, FaShieldAlt } from "react-icons/fa";

function Footer() {

const [email,setEmail]=useState("");
const [showModal,setShowModal]=useState(false);

const handleSubmit=(e)=>{
e.preventDefault();
if(!email)return;
setShowModal(true);
setEmail("");
};

return(

<footer className="bg-white text-gray-800 border-t border-lime-200 pt-16">

<div className="max-w-7xl mx-auto px-6">

{/* MAIN GRID */}

<div className="grid md:grid-cols-6 gap-10">

{/* BRAND */}

<div>
<h2 className="text-2xl font-bold text-lime-700 mb-4">
MF Blinds & Carpets
</h2>

<p className="text-sm text-gray-600 leading-relaxed">
Premium made-to-measure blinds installation and carpets fitting services across the UK.
Professional measurement, supply and installation by experienced specialists.
</p>

<div className="flex gap-3 mt-6">

<a href="https://www.instagram.com/mfblinds2002/" target="_blank">
<div className="w-9 h-9 bg-lime-600 text-white flex items-center justify-center rounded-full"><FaInstagram/></div>
</a>

<a href="https://www.facebook.com/profile.php?id=61586165050487" target="_blank">
<div className="w-9 h-9 bg-lime-600 text-white flex items-center justify-center rounded-full"><FaFacebookF/></div>
</a>

<a href="https://wa.me/447405264139" target="_blank">
<div className="w-9 h-9 bg-lime-600 text-white flex items-center justify-center rounded-full"><FaWhatsapp/></div>
</a>

<a href="https://www.tiktok.com/@mf.blinds" target="_blank">
<div className="w-9 h-9 bg-lime-600 text-white flex items-center justify-center rounded-full"><FaTiktok/></div>
</a>

</div>
</div>

{/* BLINDS TYPES */}

<div>
<h3 className="text-lg font-semibold text-lime-600 mb-5">
Blinds Types
</h3>

<ul className="space-y-2 text-sm text-gray-600">

<li><Link to="/roller-blinds">Roller Blinds</Link></li>
<li><Link to="/roman-blinds">Roman Blinds</Link></li>
<li><Link to="/vertical-blinds">Vertical Blinds</Link></li>
<li><Link to="/venetian-blinds">Venetian Blinds</Link></li>
<li><Link to="/wooden-blinds">Wooden Blinds</Link></li>
<li><Link to="/blackout-blinds">Blackout Blinds</Link></li>

</ul>
</div>

{/* ROOMS */}

<div>
<h3 className="text-lg font-semibold text-lime-600 mb-5">
Blinds by Room
</h3>

<ul className="space-y-2 text-sm text-gray-600">

<li><Link to="/living-room-blinds">Living Room Blinds</Link></li>
<li><Link to="/bedroom-blinds">Bedroom Blinds</Link></li>
<li><Link to="/kitchen-blinds">Kitchen Blinds</Link></li>
<li><Link to="/bathroom-blinds">Bathroom Blinds</Link></li>

</ul>
</div>

{/* GUIDES */}

<div>
<h3 className="text-lg font-semibold text-lime-600 mb-5">
Guides
</h3>

<ul className="space-y-2 text-sm text-gray-600">

<li><Link to="/how-to-measure-blinds">How to Measure Blinds</Link></li>
<li><Link to="/how-to-install-blinds">How to Install Blinds</Link></li>
<li><Link to="/how-to-clean-blinds">How to Clean Blinds</Link></li>
<li><Link to="/termsandconditions">Terms and Conditions</Link></li>
<li><Link to="/faq">Frequently Asked Questions</Link></li>
<li><Link to="/blog">Blog</Link></li>


</ul>
</div>

{/* SERVICE AREAS */}

<div>
<h3 className="text-lg font-semibold text-lime-600 mb-5">
Service Areas
</h3>

<ul className="space-y-2 text-sm text-gray-600">

<li><Link to="/hayes">Hayes</Link></li>
<li><Link to="/hunslow">Hunslow</Link></li>
<li><Link to="/southall">Southall</Link></li>
<li><Link to="/slough">Slough</Link></li>
<li><Link to="/uxbridge">Uxbridge</Link></li>
<li><Link to="/greenford">Greenford</Link></li>
<li><Link to="/northolt">Northolt</Link></li>
<li><Link to="/windsor">Windsor</Link></li>
<li><Link to="/ruislip">Ruislip</Link></li>
<li><Link to="/harrow">Harrow</Link></li>
<li><Link to="/maidenhead">Maidenhead</Link></li>
<li><Link to="/highwycombe">High Wycombe</Link></li>

</ul>
</div>

{/* NEWSLETTER */}

<div className="lg:w-[300px] ">

<h3 className="text-lg font-semibold text-lime-600 mb-5">
Newsletter
</h3>

<p className="text-sm text-gray-600 mb-4">
Get exclusive offers and discounts.
</p>

<form onSubmit={handleSubmit} className="flex rounded-lg overflow-hidden border">

<input
placeholder="Your email"
value={email}
onChange={(e)=>setEmail(e.target.value)}
className="px-3 py-2 w-full outline-none"
/>

<button className="bg-lime-600 text-white px-4">
Join
</button>

</form>

</div>

</div>

{/* BOTTOM */}

<div className="border-t border-lime-200 mt-14 pt-6 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500">

<p>
© 2025 MF Blinds & Carpets | All Rights Reserved
</p>

<div className="flex gap-4 mt-4 md:mt-0">
<span>Visa</span>
<span>Mastercard</span>
<span>PayPal</span>
</div>

</div>

</div>

</footer>

);

}

export default Footer;